import { render, staticRenderFns } from "./AppRadios.vue?vue&type=template&id=3572eaae"
import script from "./AppRadios.vue?vue&type=script&lang=ts"
export * from "./AppRadios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports